import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planTimelineEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-timeline/entrypoint.tsx';
import { plansHorizontalNavigationEntryPoint } from '@atlassian/jira-horizontal-nav-plans/entrypoint.tsx';

export const planTimelinePageEntryPoint = createPageEntryPoint({
	main: planTimelineEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
	horizontalNavigation: plansHorizontalNavigationEntryPoint,
});

export const planTimelinePageEntryPointWithoutHorizontalNavigation = createPageEntryPoint({
	main: planTimelineEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
